import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import BuyerCards from "components/BuyerCards";

import {
  getSaleLotGroupsByThirdPartyBuyerAndBuyerWay,
  getSaleLotGroupsByThirdPartyBuyerAndBuyerWayByRound,
} from "selectors";

const mapStateToProps = (state, props) => ({
  thirdParties: getSaleLotGroupsByThirdPartyBuyerAndBuyerWay(state),
  thirdPartiesByRound:
    getSaleLotGroupsByThirdPartyBuyerAndBuyerWayByRound(state),
  basePath: props.match.url,
});

export default compose(connect(mapStateToProps), withRouter)(BuyerCards);
